let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cS2Qc")).then(() => parcelRequire('hqUeA'));